export default __webpack_public_path__ + "static/media/ic_hong_kong.987b7724.svg";